import React from "react";
import { ReactComponent as CaretDownIcon } from "../../assets/icons/caret-down.svg";
import { ReactComponent as ArchiveIcon } from "../../assets/icons/archive.svg";

// This component represents the top bar of the Asset Dashboard, displaying the title and filter/archive options.
type AssetDashboardTopBarProps = {
  title: string;
  className?: string;
};

const AssetDashboardTopBar = ({ title, className = "" }: AssetDashboardTopBarProps) => {
  return (
    <div
      className={`flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between ${className}`}
    >
      <h3 className="text-[16px] font-semibold text-black">{title}</h3>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
        <button
          type="button"
          className="inline-flex w-full items-center gap-2 rounded-[8px] border border-eai-bg-lt2 bg-white px-3 py-2 text-xs font-medium text-[#1F2A37] sm:w-auto"
        >
          <div className="font-medium">Priority:</div>
          <span>Select</span>
          <CaretDownIcon className="h-1 w-2" />
        </button>
        <button
          type="button"
          className="inline-flex w-full items-center gap-2 rounded-[8px] border border-eai-bg-lt2 bg-white px-3 py-2 text-xs font-medium text-[#1F2A37] sm:w-auto"
        >
          <span>All Assets</span>
          <CaretDownIcon className="h-1 w-2" />
        </button>
        <button type="button" className="inline-flex items-center gap-2 text-xs font-medium text-[#1F2A37]">
          <ArchiveIcon className="h-4 w-4" />
          Archive
        </button>
      </div>
    </div>
  );
};

export default AssetDashboardTopBar;
